import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, BooleanField, Field, ArrayField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class WclapInstrumentBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new WclapInstrumentBox({
            uuid,
            graph,
            name: "WclapInstrumentBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "WclapInstrumentBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({
        type: "device",
        deviceType: "instrument",
        content: "notes",
    });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitWclapInstrumentBox, this);
    }
    get tags() {
        return WclapInstrumentBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get label() {
        return this.getField(2);
    }
    get icon() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get url() {
        return this.getField(10);
    }
    get clapId() {
        return this.getField(11);
    }
    get state() {
        return this.getField(12);
    }
    get parameters() {
        return this.getField(13);
    }
    get audioInputs() {
        return this.getField(15);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.InstrumentHost, true),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "icon",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: StringField.create({
                parent: this,
                fieldKey: 10,
                fieldName: "url",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            11: StringField.create({
                parent: this,
                fieldKey: 11,
                fieldName: "clapId",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            12: StringField.create({
                parent: this,
                fieldKey: 12,
                fieldName: "state",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            13: Field.hook({
                parent: this,
                fieldKey: 13,
                fieldName: "parameters",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.Parameter],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            15: ArrayField.create({
                parent: this,
                fieldKey: 15,
                fieldName: "audioInputs",
                deprecated: false,
                pointerRules: NoPointers,
            }, (construct) => PointerField.create(construct, Pointers.SideChain, false), 8),
        };
    }
}
